import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 motion-reduce:transition-none",
  {
    variants: {
      variant: {
        default:
          "rounded-full border-transparent bg-primary text-primary-foreground hover:bg-primary/80 shadow-sm",
        secondary:
          "rounded-full border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 shadow-sm",
        destructive:
          "rounded-full border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80 shadow-sm",
        success:
          "rounded-full border-transparent bg-success-500 text-white hover:bg-success-600 shadow-sm",
        warning:
          "rounded-full border-transparent bg-warning-500 text-white hover:bg-warning-600 shadow-sm",
        info:
          "rounded-full border-transparent bg-info-500 text-white hover:bg-info-600 shadow-sm",
        outline: "rounded-full text-foreground border-border hover:bg-accent",
        neo: "rounded-none border-2 border-[#161E54] bg-white text-[#161E54] shadow-neo-sm hover:bg-accent",
        "neo-primary": "rounded-none border-2 border-[#161E54] bg-[#F16D34] text-white shadow-neo-sm hover:bg-[#FF986A]",
        "neo-secondary": "rounded-none border-2 border-[#161E54] bg-[#BBE0EF] text-[#161E54] shadow-neo-sm hover:bg-[#9ED0E5]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
